import { DisplayStatus } from "../enums/display-status.enum";

export const validateAoi = (values) => {
  const errors: any = {};
  if (values.display === DisplayStatus.Scheduled && !values.timePeriodId) {
    errors.timePeriodId = "Time period can't be empty if display is scheduled";
  }
  return errors;
};
